import { useMemo } from 'react'
import moment from 'moment-timezone'
import useEventMetadata from './useEventMetadata'

export function useIsEventLive(eventId: number | null): boolean {
  const { data: eventMetadata } = useEventMetadata(eventId)

  const timestamps = useMemo(
    () => ({
      start: eventMetadata?.eventStartDateTime,
      end: eventMetadata?.eventEndDateTime,
    }),
    [eventMetadata]
  )

  return useMemo(() => {
    if (!timestamps.start?.timeInMillis || !timestamps.end?.timeInMillis) {
      return false
    }

    // metadata is incorrectly returning timestamps in *local* time, not UTC
    const localize = (localTimeInMillis: number, timeZone: string) => {
      const value = moment.tz(localTimeInMillis, timeZone)

      return value.subtract(value.utcOffset(), 'minutes')
    }

    const start = localize(timestamps.start?.timeInMillis, timestamps.start.timeZone)
    let end = localize(timestamps.end?.timeInMillis, timestamps.end.timeZone)

    // there is a bug in start where editing the event in CTLive causes start==end
    if (start.isSame(end)) {
      end = end.endOf('day')
    }

    const now = moment()
    const isBetween = now.isBetween(start, end)

    console.log('useIsEventLive', {
      now: now.format(),
      start: start.format(),
      end: end.format(),
      isBetween,
      timestamps,
    })

    return isBetween

  }, [timestamps])
}
